import React, { FC } from 'react';
import { DynamicPropertyCardProps } from './DynamicPropertyCard.types';
import { StyledDynamicPropertyCard } from './DynamicPropertyCard.styles';
/* eslint-disable @nx/enforce-module-boundaries */
import { CardCarouselResorts } from '@marriott/mi-leisure-components';

// Use named rather than default exports.
export const CardCarouselResortsWrapperConfig = {
  emptyLabel: 'CardCarouselResorts',
  isEmpty: false,
  resourceType: `mi-aem-leisure-spa/components/cardCarouselResorts`,
};

export const DynamicPropertyCard: FC<DynamicPropertyCardProps> = props => {
  return (
    <StyledDynamicPropertyCard
      data-testid="luxury-DynamicPropertyCard"
      data-component-name="m-luxury-DynamicPropertyCard"
    >
      <CardCarouselResorts {...props} />
    </StyledDynamicPropertyCard>
  );
};
